import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

import i18n from 'portal-base/src/decorators/i18n';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import nls from '../../locales/indexes.nls';
import { skeletonStyles } from '../../styles/skeleton.css';
import style from './ki-ds-pwa-about.css';

const CLASS_NAME = 'ki-ds-pwa-about';

@i18n(nls)
@customElement(CLASS_NAME)
export default class KiDsPwaAbout extends KiDsPwaComponent {
    static styles = [style, skeletonStyles];

    static get properties() {
        return {
            name: { type: String },
            description: { type: String },
            isLoading: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.name = '';
        this.description = '';
        this.isLoading = false;
    }

    render() {
        if (this.isLoading) {
            return html`
                <div class="about">
                    <div
                        class="skeleton-line skeleton skeleton-block"
                        style="width: 40%; height: 1.1rem;"
                    ></div>
                    <div
                        class="skeleton-line skeleton skeleton-block"
                        style="width: 80%; height: 1rem;"
                    ></div>
                </div>
            `;
        }

        if (!this.name) return nothing;

        return html`
            <div class="about hydrated">
                <div class="about-head">${this._getLabel('about')}</div>
                <div class="about-body">${this.description}</div>
            </div>
        `;
    }
}
